import { sanitizeSegment } from "../../storage/fsa.ts";
import { shortHash } from "../../storage/hash.ts";
import type { Calendar } from "./types.ts";

/**
 * Output tree for Calendar (ARCHITECTURE.md §7):
 *
 *   calendar/<calendar>.ics
 *   calendar/_raw/<calendar-key>/<eventId>.json   intermediate, same role as
 *                                                   Contacts' _raw/ and
 *                                                   Teams' messages/
 *
 * A hash suffix disambiguates the key the same way Teams' chatKey() and
 * Tasks' listKey() do — Graph does not enforce unique calendar names.
 */

const MAX_NAME_LENGTH = 60;

export async function calendarKey(calendar: Calendar): Promise<string> {
    const label = sanitizeSegment(calendar.name || "calendar", MAX_NAME_LENGTH);
    const suffix = await shortHash(calendar.id, 8);
    return `${label || "calendar"}_${suffix}`;
}

export function calendarIcsPath(key: string): string {
    return `calendar/${key}.ics`;
}

export function calendarRawDir(key: string): string {
    return `calendar/_raw/${key}`;
}

export function eventRawPath(key: string, eventId: string): string {
    return `${calendarRawDir(key)}/${sanitizeSegment(eventId)}.json`;
}
